import { lazy } from "react";
import { RouteConfig } from "./types";

// Lazy load guest components (Tailwind/shadcn)
const GuestHomePage = lazy(
  () => import("../../pages/guest/GuestHomePage"),
);
const GuestMenuPage = lazy(
  () => import("../../pages/guest/GuestMenuPage"),
);
const GuestLateCheckoutPage = lazy(
  () => import("../../pages/guest/GuestLateCheckoutPage"),
);
const GuestServicesPage = lazy(
  () => import("../../pages/guest/GuestServicesPage"),
);
const GuestChatPage = lazy(
  () => import("../../pages/guest/GuestChatPage"),
);
const GuestAIChatPage = lazy(
  () => import("../../pages/guest/GuestAIChatPage"),
);
const GuestTransfersPage = lazy(
  () => import("../../pages/guest/GuestTransfersPage"),
);
const GuestDoorControlPage = lazy(
  () => import("../../pages/guest/GuestDoorControlPage"),
);
const PaymentResultPage = lazy(
  () => import("../../pages/guest/PaymentResultPage"),
);
const GuestGuidePage = lazy(
  () => import("../../pages/guest/GuestGuidePage"),
);
const GuestWifiPage = lazy(
  () => import("../../pages/guest/GuestWifiPage"),
);
const GuestOnlineCheckinPage = lazy(
  () => import("../../pages/guest/GuestOnlineCheckinPage"),
);

/**
 * Guest routes configuration
 * These routes are protected by token validation
 */
export const guestRoutes: RouteConfig[] = [
  {
    path: "",
    element: GuestHomePage,
    title: "Home",
    titleKey: "guest_home",
    showInNav: false,
    namespaces: ["Common", "Guest.home", "Guest.general", "Guest.menu"],
    meta: {
      layout: "guest",
      requiresAuth: false,
      priority: "high",
    },
  },
  {
    path: "menu",
    element: GuestMenuPage,
    title: "Restaurant Menu",
    titleKey: "guest_menu",
    showInNav: true,
    namespaces: ["Common", "Guest.menu", "Guest.general", "Guest.payment"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "late-checkout",
    element: GuestLateCheckoutPage,
    title: "Late Checkout",
    titleKey: "guest_late_checkout",
    showInNav: true,
    namespaces: ["Common", "Guest.checkout", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "services",
    element: GuestServicesPage,
    title: "Room Services",
    titleKey: "guest_services",
    showInNav: true,
    namespaces: ["Common", "Guest.services", "Guest.general", "Service"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "chat",
    element: GuestChatPage,
    title: "Chat with Reception",
    titleKey: "guest_chat",
    showInNav: true,
    namespaces: ["Common", "Guest.chat", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
      priority: "high",
    },
  },
  {
    path: "ai-chat",
    element: GuestAIChatPage,
    title: "AI Concierge",
    titleKey: "guest_ai_chat",
    showInNav: false,
    namespaces: ["Common", "Guest.chat", "Guest.general", "Guest.menu"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "transfers",
    element: GuestTransfersPage,
    title: "Hotel Transfers",
    titleKey: "guest_transfers",
    showInNav: true,
    namespaces: ["Common", "Guest.transfers", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "door-control",
    element: GuestDoorControlPage,
    title: "Door Control",
    titleKey: "guest_door_control",
    showInNav: false,
    namespaces: ["Common", "Guest.door", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "guide",
    element: GuestGuidePage,
    title: "Hotel Guide",
    titleKey: "guest_guide",
    showInNav: true,
    namespaces: ["Common", "Guest.guide", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "wifi",
    element: GuestWifiPage,
    title: "WiFi",
    titleKey: "guest_wifi",
    showInNav: true,
    namespaces: ["Common", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "payment-result",
    element: PaymentResultPage,
    title: "Payment Result",
    titleKey: "payment_result",
    showInNav: false,
    namespaces: ["Common", "Guest.payment", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "online-checkin",
    element: GuestOnlineCheckinPage,
    title: "Online Check-in",
    titleKey: "guest_online_checkin",
    showInNav: false,
    namespaces: ["Common", "Guest.online_checkin", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
];

/**
 * Public routes (no token required)
 */
export const publicGuestRoutes: RouteConfig[] = [
  {
    path: "/qr-code-expired",
    element: lazy(() => import("../../pages/guest/QrCodeExpiredPage")),
    title: "QR Code Expired",
    titleKey: "guest_qr_expired",
    showInNav: false,
    namespaces: ["Common", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
  {
    path: "/hotel-shutdown",
    element: lazy(() => import("../../pages/guest/GuestShutdownPage")),
    title: "Hotel Temporarily Closed",
    titleKey: "guest_shutdown",
    showInNav: false,
    namespaces: ["Common", "Guest.shutdown", "Guest.general"],
    meta: {
      layout: "guest",
      requiresAuth: false,
    },
  },
];
